<script setup>
import { ref, watch, inject, computed } from "vue";
import { __, requestSimActivation } from '@/utils';
import Modal from "@components/modal.vue";
import IconSmartphone from '@components/icons/icon-smartphone.vue';
import OtpCode from "@components/otp-code.vue";
import IconPhones from '@components/icons/icon-phones.vue';
import ModalUnavailable from "@components/modal/modal-unavailable.vue";


const { selectedNumber, setSelectedNumber, setProcessStep, currentPhones } = inject('activationProcess');
const { handleSuccessPage, registrationData } = inject('step');
const isDisable = ref(true);
const showOTPPopup = ref(false);
const otpCode = ref('');
const modalUnavailable = ref(false);

const activateNumber = (number) => setSelectedNumber(number);

const esimNumbers = computed(() => currentPhones.value.filter(subscriber => subscriber.sim?.is_esim))

watch(selectedNumber, () => {
    isDisable.value = false;
});

const handleModalClose = () => {
	showOTPPopup.value = false;
	otpCode.value = '';
}

const handlePhoneSubmit = async () => {
	const payload = {
		"sim_type": selectedNumber.value.sim.is_esim ? "esim" : 'sim',
		"msisdn": selectedNumber.value.msisdn,
		"personal_id": registrationData.value.account.personal_id,
		"four_cc_digits": registrationData.value.account.four_digits,
		"sms_validation": otpCode.value || "",
	};

	const data = await requestSimActivation(payload);
}

</script>
<template>
	 <button class="btn-circle-icon" type="button" @click="handleSuccessPage">
		<span>{{ __('return') }}</span>
		<i class="ico ico--arrow-right"></i>
	</button>
	<div class="step-heading align-center">
		<h3>{{ __('Your ESIM can now be activated.') }}</h3>
		<h3><strong>{{ __('Clear subscription to playback') }}</strong></h3>
	</div>
    <div class="number-boxes">
        <div class="number-box" v-for="number in esimNumbers" :key="number.id">
            <button
				type="button"
				class="pill pill--iflex"
				:class="{'is-clicked': selectedNumber.msisdn === number.msisdn}"
				v-if="!number.active"
				@click="activateNumber(number)"
			>
				<span class="pill__inner">
					<span>{{ number.msisdn }}</span>
					<div class="pill__icon">
						<IconSmartphone />
					</div>
				</span>
            </button>
			<div class="number-box__text">
				{{ __('New line subscription') }}
			</div>
        </div>
    </div>
	<div class="steps-box__row">
		<button type="button" class="btn btn--border w149" :disabled="isDisable" @click=" setProcessStep(4)">
			<span class="btn__inner">
				{{ __('Skip Step') }}
			</span>
		</button>
		<button type="button" class="btn btn--arrows w149" :disabled="isDisable" @click="handlePhoneSubmit">
			{{ __('Continue') }}
		</button>
	</div>
	<div class="steps-box__row">
		<button type="button" class="link-underline" :disabled="isDisable" @click="sendOTP">
			{{ __('Run through eSIM activation.') }}
		</button>
	</div>
	<button type="button" class="btn btn--inline" @click="modalUnavailable = true">show unavailable</button>

	<ModalUnavailable 
		:esimNumbers="esimNumbers"
		:selectedNumber="selectedNumber"
		:isActive="modalUnavailable"
		@submit="activateNumber($event)"
		@close="modalUnavailable = false"
	/>

    <Modal :isActive="showOTPPopup" @close="handleModalClose">
		<template #head>
			<h6 class="smaller">
				{{ __('Attention - your number') }} <span class="fw-normal">{{ selectedNumber.number }}</span> {{ __('is about to be blocked!') }}
			</h6>
		</template>

		<template #body>
			<div class="notice-verification">
				<div class="notice-verification__icon">
					<IconPhones />
				</div>
				<div class="notice__body">
					<p>
						{{ __('Porting a phone number allows you to switch from one mobile phone company to another without the need to change the phone number you are used to. The goal of the mobility process is to create competition in the market by moving easily and quickly between the cellular companies.') }}
					</p>
					<p>
						{{ __('In order to enable the roaming procedure, we must make sure that this number is indeed associated with you, now we will send you a 4-digit verification code via SMS.') }}<br/>
						<strong>{{ __('The 4 sofas you received must be entered here') }}</strong>
					</p>
				</div><!-- /.notice__body -->

				<div class="notice__field">
					<div class="field-code">
						<div class="field__controls">
							<OtpCode @changed="otpCode = $event" />
						</div><!-- /.field__controls -->

						<p>
							{{ __("Didn't receive a code?") }}

							<button class="link-underline" @click="sendOTP()" type="button">
								{{ __('Click here to send it again') }}
							</button>
						</p>
					</div><!-- /.field-code -->
				</div><!-- /.notice__field -->

				<div class="notice__actions">
					<button class="notice__btn btn" @click="handlePhoneSubmit" :disabled="otpCode.length < 4" type="button">
						{{ __('Accept') }}
					</button><!-- /.btn -->
				</div><!-- /.notice__actions -->
			</div><!-- /.notice-verification -->
		</template>
	</Modal>
</template>